import { useMutation, useQuery } from '@tanstack/react-query'

import type {
  CreateCompanyRequest,
  GetCompaniesBySearchParamResponse,
  GetCompaniesResponse,
  UpdateCompanyRequest,
} from '../types/company.js'

import { apiClient } from '../lib/client.js'

export const useCreateCompanyMutation = () =>
  useMutation({
    mutationFn: async (request: CreateCompanyRequest) => {
      const response = await apiClient.client.post(`/company`, request)
      return response.data
    },
  })

export const useUpdateCompanyMutation = () =>
  useMutation({
    mutationFn: async (request: UpdateCompanyRequest) => {
      const response = await apiClient.client.put(`/company`, request)
      return response.data
    },
  })

export const useGetCompaniesQuery = () =>
  useQuery<GetCompaniesResponse>({
    queryFn: async () => {
      const response = await apiClient.client.get<GetCompaniesResponse>(`/company`)
      return response.data
    },
    queryKey: ['companies'],
  })

export const useToggleCompanyStatusMutation = () =>
  useMutation({
    mutationFn: async (companyId: string) => {
      const response = await apiClient.client.post(`/company/toggle-status/${companyId}`)
      return response.data
    },
  })

export const useReactivateAllCompaniesMutation = () =>
  useMutation({
    mutationFn: async () => {
      const response = await apiClient.client.post(`/company/reactivate-all`)
      return response.data
    },
  })

export const useGetCompaniesBySearchParamQuery = ({ searchParam }: { searchParam: string }) =>
  useQuery<GetCompaniesBySearchParamResponse>({
    enabled: searchParam.length > 0,
    queryFn: async () => {
      const response = await apiClient.client.get<GetCompaniesBySearchParamResponse>(
        `/company/search/${searchParam}`
      )
      return response.data
    },
    queryKey: ['companies', 'search', searchParam],
  })
